import { FlavourProfilesProps } from '@dcxwam/dcx-wam-ui-foundations/build/types/components/organisms/product/common/flavour-profiles'

import { getFlavourBars } from '../../common/flavour-bars'
import { getIntensityGauge } from '../../common/intensity-gauge'
import { ProductListConfig } from '../models'
import type { ProductDataVariant } from '../../../../services/product/product-data'

type Item = ProductDataVariant

const getProfiles = (
  profiles?: FlavourProfilesProps['profiles'],
  bool?: boolean
) => (profiles ? { profiles, showMultipleProfiles: bool } : undefined)

export const getFlavourProfiles = (
  variant: Partial<Item>,
  shopConfig: Partial<ProductListConfig['shopConfig']>,
  visibility: boolean
) => {
  const showIntesityGauge = visibility && Boolean(variant?.intensityMeter)
  const showFlavourProfiles =
    visibility &&
    Boolean(
      variant?.intensity || variant?.aroma || variant?.body || variant?.cooling
    )

  const showMultipleProfiles = !shopConfig?.flavourBanEnabled

  const flavourProfiles = showFlavourProfiles
    ? getFlavourBars({ ...shopConfig, ...variant })
    : undefined

  const intensityGauge = showIntesityGauge
    ? getIntensityGauge(variant?.intensityMeter, shopConfig?.intensityLabel)
    : undefined

  return getProfiles(
    showMultipleProfiles ? flavourProfiles : intensityGauge,
    showMultipleProfiles
  )
}
